export default __webpack_public_path__ + "static/media/imatge-slider-portada-5.b29cf681.jpg";